import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Box, Link } from "@mui/material";

function FAQAccordion({ summary, details }) {
  return (
    <Accordion
      elevation={4}
      sx={{
        width: "75%",
        marginBottom: "1rem",
        color: "rgb(80, 97, 117)",
        backgroundColor: "rgb(255, 255, 242)",
        borderRadius: "1rem",
        overflow: "hidden",
        "&:before": {
          display: "none",
        },
        "&.Mui-expanded": {
          margin: "0 0 1rem",
        },
      }}
    >
      <AccordionSummary expandIcon={<ArrowDropDownIcon />}>
        <Box
          sx={{
            fontSize: "1.75rem",
            fontFamily: "Pinyon",
          }}
        >
          {summary}
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box
          sx={{
            fontSize: "1rem",
            fontFamily: "Pinyon",
          }}
        >
          {details}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}

export default function FAQ() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        margin: "1rem",
      }}
    >
      <FAQAccordion
        summary="How do I RSVP?"
        details={
          <div>
            We invite you to RSVP <Link href="/rsvp">here</Link>.
          </div>
        }
      />
      <FAQAccordion
        summary="What date should I RSVP by?"
        details="September 1st, 2026"
      />
      <FAQAccordion
        summary="Can I bring a plus one?"
        details="All plus ones will be indicated on your individual RSVP."
      />
      <FAQAccordion
        summary="Are children welcome?"
        details="To help us plan, please note that invitations are limited to the guests listed on your RSVP."
      />
      <FAQAccordion
        summary="Are pets welcome?"
        details="Unfortunately, our venue does not accommodate our furry friends."
      />
      <FAQAccordion
        summary="What time should guests arrive?"
        details="Please arrive by 2:30pm at the Gates on Roblin."
      />
      <FAQAccordion summary="What time does the reception end?" details="Last call will be at 12:30am. The venue closes at 1am." />
      <FAQAccordion
        summary="Can I take photos during the ceremony?"
        details="We have hired photographers to capture moments throughout the event, and we kindly ask that guests refrain from taking their own photos during the ceremony."
      />
      <FAQAccordion
        summary="Will there be other events to attend on the wedding weekend?"
        details="Our guests are welcome to join us for a welcome dinner the day before the wedding at the McLean residence. Please see schedule tab for more details."
      />
      <FAQAccordion
        summary="Is the ceremony indoors or outdoors?"
        details="The ceremony will be held outdoors on the lawn. Cocktail hour will be held outdoors on the deck, weather permitting. The reception will be held indoors."
      />
      <FAQAccordion
        summary="What’s the venue address?"
        details={
          <div>
            The ceremony and reception will be held at{" "}
            <b>
              The Gates on Roblin - 6945 Roblin Blvd, Headingley, MB R4H 1A2
            </b>
          </div>
        }
      />
      <FAQAccordion
        summary="Where should guests park?"
        details="The venue provides free, on-site parking."
      />
      <FAQAccordion summary="Is transporation provided?" details="TBD" />
      <FAQAccordion
        summary="Is the venue wheelchair accessible?"
        details="Yes."
      />
      <FAQAccordion summary="Are there hotel room blocks?" details="TBD" />
      <FAQAccordion
        summary="What type of food will be served at the wedding?"
        details="We will be serving hors d’oeuvres at cocktail hour, followed by a sit-down “Thanksgiving-style” plated dinner."
      />
      <FAQAccordion
        summary="Will there be meal options for guests with dietary restrictions or allergies?"
        details="Yes, please indicate any dietary restrictions or allergies on your RSVP."
      />
      <FAQAccordion
        summary="Will there be an open bar?"
        details="There will be an open bar for guests to enjoy throughout cocktail hour and the reception."
      />
      <FAQAccordion
        summary="Is there a link to our wedding registry?"
        details={
          <div>
            Our wedding registry can be found <Link href="/registry">here</Link>
            .
          </div>
        }
      />
      <FAQAccordion
        summary="Where should we bring/send wedding gifts?"
        details="We’re so grateful to celebrate with you. If you’d like to give a gift, please address it to 11 Marston Drive, Headingley, MB R4H 1J6. A wedding card box will be at our reception."
      />
      <FAQAccordion
        summary="What is the dress code?"
        details="Our dress code is formal."
      />
      <FAQAccordion
        summary="What’s the weather typically like?"
        details="October in Manitoba typically brings crisp days with average temperatures in the low teens. Please dress accordingly."
      />
      <FAQAccordion
        summary="Who should I contact with questions?"
        details={
          <div>
            Please send any additional questions to{" "}
            <u>adamandtoriswedding@gmail.com</u>
          </div>
        }
      />
    </div>
  );
}
